/**
* 时间分段
*/
const timeSegments = {
  
getTimeSegmentsGroup: "/api/getTimeSegmentsGroup",//查询时间分段组
addTimeSegmentsGroup: "/api/addTimeSegmentsGroup",//新增时间分段组
modifyTimeSegmentsGroup: "/api/modifyTimeSegmentsGroup",//修改时间分段组
deleteTimeSegmentsGroup: "/api/deleteTimeSegmentsGroup",//删除时间分段组
getTimeSegments: "/api/getTimeSegments",//查询时间分段
addTimeSegments: "/api/addTimeSegments",//新增时间分段
modifyTimeSegments: "/api/modifyTimeSegments",//修改时间分段
deleteTimeSegments: "/api/deleteTimeSegments",//删除时间分段
getRhythmicsOfSegmentTime: "/api/getRhythmicsOfSegmentTime",//查询时间分段规律
addRhythmicsOfSegmentTime: "/api/addRhythmicsOfSegmentTime",//新增时间分段规律
modifyRhythmicsOfSegmentTime: "/api/modifyRhythmicsOfSegmentTime",//修改时间分段规律
deleteRhythmicsOfSegmentTime: "/api/deleteRhythmicsOfSegmentTime",//删除时间分段规律表
}

export default timeSegments